import { render } from "./GraficoProjetosPorGerente.vue?vue&type=template&id=65c7869e&scoped=true"
import script from "./GraficoProjetosPorGerente.vue?vue&type=script&lang=js"
export * from "./GraficoProjetosPorGerente.vue?vue&type=script&lang=js"

import "./GraficoProjetosPorGerente.vue?vue&type=style&index=0&id=65c7869e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c7869e"]])

export default __exports__